import { render, staticRenderFns } from "./WebsiteGoodsCategoryDetail.vue?vue&type=template&id=73ca6640&scoped=true&"
import script from "./WebsiteGoodsCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./WebsiteGoodsCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ca6640",
  null
  
)

export default component.exports